// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/partners.scss
// module id = 45
// module chunks = 0